// import service from '../service'
import service from './contactsService'
import { configer } from '@/config'

const baseUrl = configer.baseURL

// 获取ali-oss token和bucket
export function getOssSecurityToken(params) {
    return service({
        url: baseUrl + `/contacts/open/portrait/getOssSecurityToken`,
        method: 'get',
        params
    })
}
